import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeatureManualService } from 'src/app/kuba/feature-documents/feature-document.services';
import { BaseServices } from 'src/app/kuba/kuba.services';
@Injectable()
export class DocumentListResolver {
  constructor(private backend: FeatureManualService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    // Resolvers run before the Flexi shell, including on direct R-mode links.
    const isFlexi = route.pathFromRoot.some(
      parent => parent.routeConfig?.path === 'Flexi'
    );
    if (isFlexi) {
      const routedBusinessId = Number(
        route.pathFromRoot
          .find(parent => parent.routeConfig?.path === 'business/:id')
          ?.paramMap.get('id')
      );
      const businessId =
        routedBusinessId > 0 ? routedBusinessId : BaseServices.BusinessId;
      // The document editor and its write services still read this legacy context.
      sessionStorage.setItem(
        'workingModule',
        JSON.stringify({ id: 60, name: 'Flexi' })
      );
      return this.backend.getFeatureManualTreeBytree(60, businessId);
    }
    return this.backend.getFeatureManualTree(route.params['Id']);
  }
}
